import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: start;
  align-items: center;
  margin-right: 1rem;
`;
